import {SchemaSummary} from 'constants/RegistryConstants';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {TableColumnType} from 'notebook/tables/TableConstants';
import {StorableSchemaSummary} from 'samples/storables/StorableSchemaConstants';
import {getRequiredLinkTagSchema, RequiredLinkStorableSchema} from 'schemas/fields/SchemaFieldConstants';

export function getSchemaForColumn(
  columnDefinition: ColumnDefinition
): StorableSchemaSummary | SchemaSummary | null {
  if (columnDefinition.type === TableColumnType.TAG_VALUE) {
    return getRequiredLinkTagSchema(columnDefinition.schemaField);
  }
  if (
    columnDefinition.type === TableColumnType.EXISTING_BIOENTITY &&
    columnDefinition.tagSchemaOrInterface !== 'ALL'
  ) {
    return columnDefinition.tagSchemaOrInterface;
  }
  if (columnDefinition.type === TableColumnType.CONTAINERS) {
    return (
      (columnDefinition.linkedSampleSchemaField?.requiredLink as RequiredLinkStorableSchema)
        ?.storableSchema ?? null
    );
  }
  // TODO(BNCH-128762): Handle extracting schema from antibody domain columns.
  return null;
}
